import { useMemo } from 'react';
import BaseLayer from 'ol/layer/Base';
import { useMapSources } from '@/utils/context/mapSourcesContext';
import { createContentLayers } from '@/components/Map/MapViewer/utils/config/createContentLayers';
import { MapConfig } from '../../MapViewer.types';

export const useOlMapLayers = (): MapConfig['layers'] => {
  const sources = useMapSources();

  const contentLayers = useMemo(() => createContentLayers(sources), [sources]);

  return useMemo(() => {
    const result: BaseLayer[] = [...contentLayers];
    sources.additionalLayers.forEach(vectorLayer => {
      result.push(vectorLayer);
    });

    return result;
  }, [contentLayers, sources.additionalLayers]);
};
